import {
  CREATE_REPORT_CUSTOM_VIEW,
  CREATE_REPORT_CUSTOM_VIEW_SUCCESS,
  CREATE_REPORT_CUSTOM_VIEW_FAILURE,
  FETCH_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW_SUCCESS,
  FETCH_REPORT_CUSTOM_VIEW_FAILURE,
  SELECT_REPORT_CUSTOM_VIEW,
  SELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  SELECT_REPORT_CUSTOM_VIEW_FAILURE,
  DELETE_REPORT_CUSTOM_VIEW,
  DELETE_REPORT_CUSTOM_VIEW_SUCCESS,
  DELETE_REPORT_CUSTOM_VIEW_FAILURE,
  RESET_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_REPORT_CUSTOM_VIEW,
  UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  UNSELECT_REPORT_CUSTOM_VIEW_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE,
  SET_DEFAULT_CUSTOM_VIEW,
  DELETE_DEFAULT_CUSTOM_VIEW,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPOR_JOBT_LISTING_FAILURE,
  SET_JOB_DEFAULT_CUSTOM_VIEW,
  DELETE_JOB_DEFAULT_CUSTOM_VIEW,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS,
} from "./actionTypes";

import {
  errorMetaData,
  pendingMetaData,
  resetAllMetaData,
  successMetaData,
} from "@workspace/common";

const initialState = {
  report: {},
  reportData: null,
  reports: null,
  reportsMeta: {},
  reportsFields: [],
  reportsFieldsAll: [],
  meta: {},
  createMeta: {},
  updateMeta: {},
  deleteMeta: {},
  tableMeta: {},

  reportCustomView: {},
  reportCustomViewMeta: {},
  reportCustomViews: null,
  deleteReportsMeta: {},

  jobReportCustomView: {},
  jobReportCustomViewMeta: {},
  jobReportCustomViews: null,
  deleteJobReportsMeta: {},

  jobUniversalReportCount: [],
  jobUniversalReportCountMeta: {},
  jobUniversalReportJobCount:[],
  jobUniversalReportJobCountMeta: {},

  jobUniversalReportListing: [],
  jobUniversalReportListingMeta: {},
  jobUniversalReportJobListing: [],
  jobUniversalReportJobListingMeta: {},

  defaultCustomView: {},
  jobDefaultCustomView: {},
};

const ReportReducer = (state = initialState, action) => {
  switch (action.type) {
    // Create Report Custom View
    case CREATE_REPORT_CUSTOM_VIEW:
      const { type } = action.payload;
      if (type === "Job Universal Report") {
        return {
          ...state,
          reportCustomViewMeta: pendingMetaData(),
        };
      }
      if (type === "Job Universal Report - Job Listing") {
        return {
          ...state,
          jobReportCustomViewMeta: pendingMetaData(),
        };
      }
    case CREATE_REPORT_CUSTOM_VIEW_SUCCESS:
      const { reportCustomView, viewType } = action.payload;
      if (viewType === "Job Universal Report") {
        return {
          ...state,
          reportCustomView: reportCustomView,
          reportCustomViewMeta: successMetaData(action.payload),
        };
      } else if (viewType === "Job Universal Report - Job Listing") {
        return {
          ...state,
          jobReportCustomView: reportCustomView,
          jobReportCustomViewMeta: successMetaData(action.payload),
        };
      }
    case CREATE_REPORT_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        reportCustomViewMeta: errorMetaData(action.payload),
      };
    // Fetch Report Custom Views
    case FETCH_REPORT_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_REPORT_CUSTOM_VIEW_SUCCESS:
      const payload = action.payload;
      if (payload?.viewType === "Job Universal Report") {
        return {
          ...state,
          loading: false,
          reportCustomViews: payload?.reportCustomViews,
        };
      }
      if (payload?.viewType === "Job Universal Report - Job Listing") {
        return {
          ...state,
          loading: false,
          jobReportCustomViews: payload?.reportCustomViews,
        };
      }
    case FETCH_REPORT_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case RESET_REPORT_CUSTOM_VIEW:
      return {
        ...state,
        reportCustomViews: null,
      };
    // Select Report Custom View
    case SELECT_REPORT_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SELECT_REPORT_CUSTOM_VIEW_SUCCESS:
      if (action.payload?.viewType === "Job Universal Report") {
        return {
          ...state,
          loading: false,
          reportCustomView: action.payload?.reportCustomView,
        };
      }
      if (action.payload?.viewType === "Job Universal Report - Job Listing") {
        return {
          ...state,
          loading: false,
          jobReportCustomView: action.payload?.reportCustomView,
        };
      }
    case SELECT_REPORT_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    // Delete Report Custom View
    case DELETE_REPORT_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case DELETE_REPORT_CUSTOM_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        reportCustomView: action.payload,
      };
    case DELETE_REPORT_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case FETCH_REPORT_CUSTOM_VIEW_BY_ID:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS:
      if (action.payload?.type === "Job Universal Report") {
        return {
          ...state,
          reportCustomView: action.payload,
          reportCustomViewMeta: successMetaData(action.payload),
        };
      }
      if (action.payload?.type === "Job Universal Report - Job Listing") {
        return {
          ...state,
          jobReportCustomView: action.payload,
          jobReportCustomViewMeta: successMetaData(action.payload),
        };
      }
    case FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case EDIT_REPORT_CUSTOM_VIEW_BY_ID:
      if (action.payload?.payload?.type === "Job Universal Report") {
        return {
          ...state,
          reportCustomViewMeta: pendingMetaData(),
        };
      }
      if (
        action.payload?.payload?.type === "Job Universal Report - Job Listing"
      ) {
        return {
          ...state,
          jobReportCustomViewMeta: pendingMetaData(),
        };
      }
    case EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS:
      if (action.payload?.type === "Job Universal Report") {
        return {
          ...state,
          reportCustomView: action.payload,
          reportCustomViewMeta: successMetaData(action.payload),
        };
      }
      if (action.payload?.type === "Job Universal Report - Job Listing") {
        return {
          ...state,
          jobReportCustomView: action.payload,
          jobReportCustomViewMeta: successMetaData(action.payload),
        };
      }
      return {
        ...state,
        reportCustomView: action.payload,
        reportCustomViewMeta: successMetaData(action.payload),
      };
    case EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        reportCustomViewMeta: errorMetaData(action.payload),
      };
    case UNSELECT_REPORT_CUSTOM_VIEW:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS:
      if (action?.payload === "Job Universal Report") {
        const newReportCustomViews = state.reportCustomViews.map((view) => {
          if (view?.selected === true) {
            view.selected = false;
          }
          return view;
        });
        return {
          ...state,
          loading: false,
          reportCustomViews: newReportCustomViews,
        };
      }
      if (action?.payload === "Job Universal Report - Job Listing") {
        const newJobReportCustomViews = state.jobReportCustomViews.map(
          (view) => {
            if (view?.selected === true) {
              view.selected = false;
            }
            return view;
          }
        );
        return {
          ...state,
          loading: false,
          jobReportCustomViews: newJobReportCustomViews,
        };
      }
    case UNSELECT_REPORT_CUSTOM_VIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case FETCH_JOB_UNIVERSAL_REPORT_COUNT:
      return {
        ...state,
        jobUniversalReportCountMeta: pendingMetaData(),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS:
      return {
        ...state,
        jobUniversalReportCount: action.payload,
        jobUniversalReportCountMeta: successMetaData(action.payload),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        jobUniversalReportCountMeta: errorMetaData(action.payload),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_LISTING:
      return {
        ...state,
        jobUniversalReportListingMeta: pendingMetaData(),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS:
      return {
        ...state,
        jobUniversalReportListingMeta: successMetaData(action.payload),
        jobUniversalReportListing: action.payload,
      };
    case FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE:
      return {
        ...state,
        jobUniversalReportListing: [],
        jobUniversalReportListingMeta: errorMetaData(action.payload),
      };
    case SET_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        defaultCustomView: action.payload,
      };
    case DELETE_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        defaultCustomView: {},
      };
    case FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING:
      return {
        ...state,
        jobUniversalReportJobListingMeta: pendingMetaData(),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS:
      return {
        ...state,
        jobUniversalReportJobListingMeta: successMetaData(action.payload),
        jobUniversalReportJobListing: action.payload,
      };
    case FETCH_JOB_UNIVERSAL_REPOR_JOBT_LISTING_FAILURE:
      return {
        ...state,
        jobUniversalReportJobListing: [],
        jobUniversalReportJobListingMeta: errorMetaData(action.payload),
      };
    case SET_JOB_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        jobDefaultCustomView: action.payload,
      };
    case DELETE_JOB_DEFAULT_CUSTOM_VIEW:
      return {
        ...state,
        jobDefaultCustomView: {},
      };
    case FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT:
      return {
        ...state,
        jobUniversalReportJobCountMeta: pendingMetaData(),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS:
      return {
        ...state,
        jobUniversalReportJobCount: action.payload,
        jobUniversalReportJobCountMeta: successMetaData(action.payload),
      };
    case FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE:
      return {
        ...state,
        errorMsg: action.payload,
        jobUniversalReportJobCountMeta: errorMetaData(action.payload),
      };
    default:
      return state;
  }
};

export default ReportReducer;
